import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "index-content" }
const _hoisted_2 = { class: "nav-bar" }
const _hoisted_3 = { class: "swiper" }
const _hoisted_4 = { class: "wow animate__fadeInUpBig company-profile" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "introduce-text" }
const _hoisted_7 = { class: "advantage wow animate__fadeInUpBig" }
const _hoisted_8 = { class: "advantage-pc" }
const _hoisted_9 = { class: "top" }
const _hoisted_10 = { class: "bottom" }
const _hoisted_11 = { class: "advantage-phone" }
const _hoisted_12 = { class: "top" }
const _hoisted_13 = { class: "bottom" }
const _hoisted_14 = { class: "choose-us wow animate__fadeInUpBig" }
const _hoisted_15 = { class: "top" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "tips" }
const _hoisted_18 = { class: "bottom" }
const _hoisted_19 = { class: "left-icon" }
const _hoisted_20 = { class: "right-content" }
const _hoisted_21 = { class: "title" }
const _hoisted_22 = { class: "tips" }

import NavBar from '@/components/NavBar.vue'
import { UtilMethods } from '@/util/UtilMethods'
import Swiper from '@/components/Swiper.vue'
import FloatButton from '@/components/FloatButton.vue'
import { onBeforeMount, onMounted, Ref, ref } from 'vue'
import { Action, LanguageType } from '@/typeDefine/CommonTypes'
import HotSales from '@/components/HotSales.vue'
import Footer from '@/components/Footer.vue'
import { useI18n } from 'vue-i18n'
import { LanguagePackageType } from '@/typeDefine/EntityType'
import { router } from '@/router'


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const { t} = useI18n<[LanguagePackageType], LanguageType>()

const maxZIndex: string = UtilMethods.getDOMStyleFromCSS('--max-z-index')

//floatButton子组件ref
const floatButtonRef: Ref<InstanceType<typeof FloatButton> | null> = ref(null)

//选择我们的理由
const chooseUsItem = [
    {
        title: 'index.chooseUs.chooseItem[0].title',
        icon: `icon-youshi_youzhi`,
        tips: 'index.chooseUs.chooseItem[0].tips',
    },
    {
        title: 'index.chooseUs.chooseItem[1].title',
        icon: `icon-youshi_youzhi`,
        tips: 'index.chooseUs.chooseItem[1].tips',
    },
    {
        title: 'index.chooseUs.chooseItem[2].title',
        icon: `icon-youshi_youzhi`,
        tips: 'index.chooseUs.chooseItem[2].tips',
    }
] as const

//监听轮播视口事件
const onViewport: Action<[boolean]> = (value: boolean) => {
    if (floatButtonRef.value) {
        floatButtonRef.value.floatButtonDisplayHandler(value)
    }
}

const goAboutUsPage: Action = () => {
    router.push({
        name: 'aboutUs'
    })
}


return (_ctx: any,_cache: any) => {
  const _component_el_affix = _resolveComponent("el-affix")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_affix, { "z-index": _unref(maxZIndex) }, {
        default: _withCtx(() => [
          _createVNode(NavBar)
        ]),
        _: 1
      }, 8, ["z-index"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Swiper, { onViewport: onViewport })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('index.companyProfile.title')), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('index.companyProfile.introduce')), 1),
      _createElementVNode("div", {
        class: "learn-more-button",
        onClick: goAboutUsPage
      }, " LEARN MORE ")
    ]),
    _createVNode(HotSales),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.$tm('index.advantage') as any), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "advantage-item",
            key: index
          }, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.top), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(item.bottom), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.$tm('index.advantage') as any), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "advantage-item",
            key: index
          }, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(item.top), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString(item.bottom), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('index.chooseUs.title')), 1),
        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('index.chooseUs.tips')), 1)
      ]),
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(chooseUsItem, (item, index) => {
          return _createElementVNode("div", {
            class: "choose-item",
            key: index
          }, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("i", {
                class: _normalizeClass([
                            'iconfont',item.icon
                        ])
              }, null, 2)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t(item.title)), 1),
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t(item.tips)), 1)
            ])
          ])
        }), 64))
      ])
    ]),
    _createVNode(Footer),
    _createVNode(FloatButton, {
      ref_key: "floatButtonRef",
      ref: floatButtonRef
    }, null, 512)
  ]))
}
}

})